<section>
  <div class="header astral-page-header">
    <h1>{{ 'DIRECT_DEBIT.LIST_HEADER' | translate }}</h1>
    <astral-popover [helpText]="'DIRECT_DEBIT.HEADER_TOOLTIP'"></astral-popover>
  </div>
  <form class="filter astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
      <astral-date-picker
        [control]="form.controls['from']"
        [label]="'DIRECT_DEBIT.FROM'"
        [model]="from"
        [isRequired]="true"
      ></astral-date-picker>
      <astral-date-picker
        [control]="form.controls['to']"
        [label]="'DIRECT_DEBIT.TO'"
        [model]="to"
        [isRequired]="true"
      ></astral-date-picker>
      <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
      <astral-input [control]="form.controls['payerName']"></astral-input>
      <div class="astral-form-adjacent-action">
        <astral-button variant="secondary" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      </div>
    </astral-layout-group>
  </form>
  @if (dataContext) {
    <app-list-view
      [columnDefinition]="columnDefinitions"
      [contextMenuDefinition]="contextMenuDefinition"
      [itemsSource]="dataContext"
      [preferencesKey]="preferencesKey"
    ></app-list-view>
  }
</section>
